import { ButtonHTMLAttributes, FC } from 'react';
import Button from './Button';
import { IDataTestId } from '../../../../../custom';
import { ISubmitButtonLabels } from './constants/Button.interface';
import { SUBMIT_BUTTON_LABELS } from './constants/Button.constants';

const SubmitButton: FC<
  ButtonHTMLAttributes<HTMLButtonElement> & IDataTestId & { labelVariant?: ISubmitButtonLabels }
> = (props) => {
  const { labelVariant = SUBMIT_BUTTON_LABELS.save, ...rest } = props;
  return (
    <Button
      {...rest}
      type="submit"
      variant="primary"
      testId={props?.['data-testid'] || 'submit-btn'}
      label={labelVariant}
    />
  );
};

export default SubmitButton;
